
enum CalendarSettingsDefaultDisplayType {
    NONE='NONE', MEDIAN='MEDIAN', WEIGHTED_AVERAGE='WEIGHTED_AVERAGE', RANKING='RANKING', AVAILABILITY='AVAILABILITY', SOLD_OUT='SOLD_OUT'
}

export default CalendarSettingsDefaultDisplayType;